import { useEffect, useState } from 'react'

import useAppSelector from '../../../hooks/useAppSelector'
import { useUpdateOnboardingChecklistMutation } from '../../../hooks/useUpdateOnboardingChecklistMutation'
import { isOfficeParent } from '../../../lib/helpers/officeHelpers'
import { selectOnboardingChecklist } from '../../../redux/slices/onboardingChecklist'

// If not already done, mark the outlook step as completed when the user uses
// Outlook for the first time
export default function useCompleteOutlookOnboardingChecklistIfIsOfficeEffect() {
  const checklist = useAppSelector(selectOnboardingChecklist)
  const updateChecklistMutation = useUpdateOnboardingChecklistMutation()
  const [isDone, setIsDone] = useState<boolean>(false)

  return useEffect(() => {
    // If Outlook is already done, don't waste any more time
    if (isDone || !checklist || checklist?.outlook) {
      return
    }

    if (!isOfficeParent()) {
      return
    }

    // Because checklist will mutate and trigger this again
    setIsDone(true)

    updateChecklistMutation.mutate({
      checklistId: checklist?.id,
      request: { outlook: true },
    })
  }, [isDone, checklist, updateChecklistMutation])
}
